module.exports = __webpack_public_path__ + "img/3.75f5744b.jpg";